export class BidderRoutes {
	private baseRoute = 'bidder';

	campaigns() {
		return `/${this.baseRoute}/campaigns`;
	}

	models() {
		return `/${this.baseRoute}/models`;
	}

	editModel(modelNameParam: string) {
		return `/${this.baseRoute}/models/edit/${modelNameParam}`;
	}

	createCampaign() {
		return `/${this.baseRoute}/campaigns/create`;
	}

	editCampaign(id: string) {
		return `/${this.baseRoute}/campaigns/${id}/edit`;
	}

	duplicateCampaign(id: string) {
		return `/${this.baseRoute}/campaigns/${id}/duplicate`;
	}

	updateMaxLossClicks() {
		return `/${this.baseRoute}/update-max-loss-clicks`;
	}
}
